// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Dynamically resize istock homepage category tiles and hero image
$(window).load(function () {
  resizeTallTile();

  return $(window).resize(function () {
    resizeTallTile();
    return resizeHero();
  });
});

var resizeTallTile = function () {
  const col2 = $('#category-tiles .col2');
  const imgHeight = col2.find('.tile').height();
  const titleHeight = col2.find('h5').height();
  return $('#category-tiles .col3 .img').height(
    (imgHeight - titleHeight) * 2 + 35
  );
};

var resizeHero = function () {
  const MAX_HEIGHT = 700;
  const fontSize = $('.headline').css('font-size') || '16px';
  const lineHeight = Math.floor(parseInt(fontSize.replace('px', '')) * 1.5);
  const hintHeight = 120;
  const minHeight = 200;
  const newHeight = Math.min(
    Math.max(
      $(window).height() - $('#header-container').height() - hintHeight,
      minHeight
    ),
    MAX_HEIGHT
  );

  return $('.hero').height(newHeight);
};

$(document).ready(function () {
  $('.tile, .feature-tile').click(function () {
    return $(document).trigger('track.landing.tileClick', {
      content: $(this).attr('data-nav'),
    });
  });
  return $(
    '.feature-tile a[href="https://www.invisionapp.com/craft#stock"]'
  ).click(() =>
    $(document).trigger('track.inVisionPlugin.Download', {
      content: 'messaging_FMA_Invision_Plugin',
    })
  );
});
